<div class="w-full flex justify-content-center">
  <div class="page-section" [class]="fullWidth() ? 'p-0' : 'page-section-x-padded'">
    @if (sharedContainerModel()) {
      <ppg-container-603010 [model]="sharedContainerModel()!"></ppg-container-603010>
    }
  </div>
</div>
